import React from 'react';
import SideNavbar from "../AdminNavbar/SideNavbar";

function AdminAbout() {
  return (
    <div>
      <SideNavbar />
      <h1>Admin About</h1>
    </div>
  );
}

export default AdminAbout;
